import script from "./ModalTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./ModalTemplate.vue?vue&type=style&index=0&id=dfb053fe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfb053fe"]])

export default __exports__